// extracted by mini-css-extract-plugin
export default {"Tooltip":"CiEFMFro5tZ9iZpvIrTe"};